import { combineReducers } from "redux-immutable";

import TeacherAssignmentsMetaState from "../../../models/TeacherAssignmentsMetaState";

import teacherAssignmentsCrudMetaReducer from "./individualAssignments";
import {
  classAllAssignmentsMetaReducer,
  classFutureAssignmentsMetaReducer
} from "./classAssignments";

export default combineReducers(
  {
    individualAssignments: teacherAssignmentsCrudMetaReducer,
    pastAssignments: classAllAssignmentsMetaReducer,
    futureAssignments: classFutureAssignmentsMetaReducer
  },
  () => new TeacherAssignmentsMetaState() as any
);
